import { useDocumentTitle } from '@/shared/hooks';
import { useToast } from '@/shared/contexts/ToastContext';
import { ACCOUNT_ACCENT } from './accountStyles';
import { TerritoryMap } from './TerritoryMap 2';
import {
  useGenerateTerritoryFsas,
  useSaveTerritory,
  useTerritory
} from './hooks/useTerritory';

const AccountTerritoryPage = () => {
  useDocumentTitle('Territory - BrokerMax');
  const { notify } = useToast();
  const { data, isLoading } = useTerritory();
  const saveMutation = useSaveTerritory();
  const generateFsasMutation = useGenerateTerritoryFsas();

  return (
    <div className="relative z-10">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
        Territory
      </h1>
      <p className="mt-1 max-w-xl text-sm text-slate-700">
        Manage your desired target territory.
      </p>

      {isLoading ? (
        <div
          className={`mt-8 rounded-xl p-8 ${ACCOUNT_ACCENT.cardSurface} text-center text-sm text-slate-500`}
        >
          Loading territory…
        </div>
      ) : (
        <div className="mt-8">
          <TerritoryMap
            initial={data?.territory ?? null}
            isSaving={saveMutation.isPending}
            isGeneratingFsas={generateFsasMutation.isPending}
            onGenerateFsas={async body => {
              const response = await generateFsasMutation.mutateAsync(body);
              return response.postalFsaPrefixes;
            }}
            onSave={async body => {
              try {
                await saveMutation.mutateAsync(body);
                notify('success', 'Territory saved.');
              } catch (e) {
                notify(
                  'warning',
                  e instanceof Error ? e.message : 'Could not save'
                );
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AccountTerritoryPage;
